module.exports = __webpack_public_path__ + "static/media/adagietto.0dd9da9e.webp";